import { type IOType, type TargetWidgetData, type WidgetData } from '@terros/common'
import { type SelectItem } from '../types'
import { type TranslateFunction } from '../i18n'
import { ColorPrimitives } from '../color'
import { type ManagerDashboardViewAs } from './stats'

export const stringifyWidgetType = (widgetType: WidgetData['type'], ioType: IOType, t: TranslateFunction): string => {
  return getBaseWidgetText(widgetType, ioType, t)
}

const getBaseWidgetText = (widgetType: WidgetData['type'], ioType: IOType, t: TranslateFunction): string => {
  switch (widgetType) {
    case 'ratio':
      return t('Conversion')
    case 'averagePerPeriod':
      return t('{{ioType}} Insights', { ioType: t(stringifyIoType(ioType)) })
    case 'customFields':
      return t('Custom Fields')
    case 'daysSince':
      return t('Days Since')
    case 'daysWorked':
      return t('Days Worked')
    case 'game':
      return t('Competition')
    case 'timeline':
      return t('Timeline')
    case 'program':
      return t('Program')
    case 'teamEngagement':
      return t('Team Engagement')
    case 'skillScore':
      return t('Skill Insights')
    case 'production':
      return t('Production')
    case 'question':
      return t('Question')
  }
}

export const getQuartileColor = (percentage: number): string => {
  if (percentage === -1) return ColorPrimitives.neutral['500']
  if (percentage < 25) return ColorPrimitives.rose['600']
  if (percentage < 50) return ColorPrimitives.orange['500']
  if (percentage < 75) return ColorPrimitives.yellow['500']
  return ColorPrimitives.emerald['500']
}

export const getMetricDataTarget = ({ target, value }: Pick<TargetWidgetData, 'target' | 'value'>): number => {
  if (target === undefined || target === 0) return value
  return target
}

export const stringifyViewAs = (viewAs: ManagerDashboardViewAs): string => {
  if (viewAs.scope === 'user') return 'Personal'
  if (viewAs.scope === 'manager') return 'Direct reports'
  return 'Team'
}

export const stringifyIoType = (ioType: IOType): string => {
  switch (ioType) {
    case 'Input':
      return 'Hustle'
    case 'Output':
      return 'Results'
    default:
      return ioType
  }
}

export const IO_TYPE_SELECT_OPTIONS: SelectItem<IOType>[] = [
  { label: stringifyIoType('Input'), value: 'Input' },
  { label: stringifyIoType('Output'), value: 'Output' },
]
